<!-- src/components/ContactsView.vue -->

<template>
    <section class="contacts">
        <search-bar
            v-model="params.query"
            v-on:search="onSearch"
            placeholder="Search for contact"></search-bar>
      <advanced-search
          v-model="params.advanced"
          v-on:search="onAdvancedSearch"></advanced-search>

        <vue-table
            :columns="columns"
            :rows="rows"
            :total-rows="totalRows"
            :current-page="params.page"
            :per-page="params.perPage"
            v-on:selected-row="onSelectRow"
            v-on:change-sort="onChangeSort"
            v-on:selected-page="onSelectPage">
            <div class="table-options" slot="options">
                <div class="table-options-left">
                    <status-block
                        :current-status="params.tag"
                        :options="tags"
                        v-on:selected-status="onSelectStatus">Folder Filter</status-block>
                </div>
                <div class="table-options-right">
                    <vue-button
                        @click="downloadCsv()"
                        v-if="allowDownload"
                        type="green"
                        icon="icon-download">Download CSV</vue-button>
                </div>
            </div>
        </vue-table>
    </section>
</template>

<script>

import Vue from 'vue/dist/vue'
import VueTable from '../Shared/VueTable.vue';
import VueButton from '../Shared/VueButton.vue';
import StatusBlockCircle from '../Shared/StatusBlockCircle.vue';
import SearchBar from '../Shared/SearchBar.vue';
import StatusBlock from '../Shared/StatusBlock.vue';
import WebServices from '../../services/WebServices';
import Parameters from '../../mixins/Parameters';
import Format from '../../mixins/Format';
import AdvancedSearch from '../Shared/AdvancedContactSearch.vue';

export default {

    mixins: [ Parameters, Format ],

    components: { VueTable, SearchBar, VueButton, StatusBlock, StatusBlockCircle, AdvancedSearch },

    data () {
        return {
            contactServices: WebServices("Contacts"),
            columns: {
                first_name: {
                    title: "First Name"
                },
                last_name: {
                    title: "Last Name"
                },
                title: {
                    title: "Title"
                },
                company_name: {
                    title: "Company"
                },
                company_type: {
                    title: "Company Type",
                    transform: function(value) {
                        if (value) {
                            return value["name"];
                        }
                        return "–";
                    }
                },
                email: {
                    title: "Email"
                },
                city: {
                    title: "City"
                },
                state: {
                    title: "State"
                },
                created_at: {
                    title: "Created",
                    transform: function(value) { return this.utcToLocal(value, "MM/DD/YY") }.bind(this)
                },
                updated_at: {
                    title: "Updated",
                    transform: function(value) { return this.utcToLocal(value, "MM/DD/YY") }.bind(this)
                },
                tag: {
                    title: "Folder",
                    transform: function(value) {
                        if (value && value.length > 0) {
                            return '<a class="status-block-circle" style="background:'+value[0].color+'"></a>';
                        }
                        return '';
                    },
                    html: true
                }
            },
            rows: null,
            params: {
                query: "",
                page: 1,
                perPage: 15,
                orderBy: null,
                orderDirection: null,
                mine: 0,
                advanced: {},
                tag: null
            },
            totalRows: 0,
            allowDownload: this.$root.$data.auth.user.allowDownload,
            tags: this.$root.$data.auth.user.contactTags
        }
    },

    created () {

        this.params = this.getParameters();
        this.loadInitial();
    },

    methods: {

        loadInitial () {

            this.params = this.getParameters();
            this.params.mine = this.$route.name.indexOf("contacts.mine") === 0;
            if (this.$route.params.tagId) {
                this.params.tag = parseInt(this.$route.params.tagId || 0);
            }

            this.getAll()
        },

        getAll () {
            this.contactServices.getAll(this.params)
            .then(function(response) {
                var properties = response.data.data;
                this.totalRows = properties.total;
                this.rows = properties.data;
            }.bind(this));
        },

        // @todo convert contact download to queue
        downloadCsv () {
            this.postParameters('/api/frontend/V1/Contacts/Download', this.params, this.$root.$data.auth.getToken());
        },

        onSearch (query) {
            this.params.page = 1;
            this.params.query = query;
            this.setParameters(this.params);
        },

        onSelectRow (row) {
            this.$router.push({ name: 'contacts.show', params : { contactId: row.id, row: row } });
        },

      onAdvancedSearch () {

        var jsonString = JSON.stringify(this.params.advanced);
        var isJson = true;
        if (jsonString.indexOf("%") >= 0) {
          var newJson = decodeURIComponent(jsonString.toString());
          newJson = newJson.substr(1);
          newJson = newJson.substr(0, newJson.length - 1)
          newJson = JSON.parse(newJson);
          this.params.advanced = newJson;
        }
        console.log("Advanced Search");
        this.params.page = 1;
        this.setParameters(this.params);
      },

        onChangeSort (sort) {
            this.params.orderBy = sort.column;
            this.params.orderDirection = sort.direction;
            this.setParameters(this.params);
        },

        onSelectPage (page) {
            this.params.page = page;
            this.setParameters(this.params);

            document.body.scrollTop = document.documentElement.scrollTop = 0
        },

        onSelectStatus (status) {

            var tag_id = status.id;
            if (tag_id == this.params.tag) {
                tag_id = null;
            }
            this.params.tag = tag_id;
            this.setParameters(this.params);
        },
    },

    watch: {
        '$root.$data.auth.user': {
            handler: function (val, oldVal) {
                this.tags = this.$root.$data.auth.user.contactTags;
                this.allowDownload = this.$root.$data.auth.user.allowDownload;
            },
            deep: true
        },
        '$route': function() {
            this.loadInitial()
        }
    },
}

</script>
